import React, { useCallback, useEffect, useMemo, useState } from "react";
import style from "./index.module.scss";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Space } from "antd";
import { get, getFloat, post, postForA8bnc2ik } from "common/utils.js";
import moment from "moment";
import * as echarts from "echarts~5/lib/echarts";
import DomResize from "components/DomResize";
import './DailyResult.scss';
import * as XLSX from "xlsx";
// // 引入柱状图
// import 'echarts/lib/chart/bar';
// // 引入提示框和标题组件
// import 'echarts/lib/component/tooltip';
// import 'echarts/lib/component/title';

// import echarts from 'echarts';
import { getCachedUserInfo } from "common/utils.js";
import {
  DailyPredictionColumns,
} from "./utils";
import ExcellentExport from "excellentexport";
import {
  LeftOutlined,
  RightOutlined,
  DownloadOutlined,
} from "@ant-design/icons";
let timeRange = [];
for (let index = 0; index < 24; index++) {
  timeRange.push(`${index + 1}:00`);
}


const top1DataUrl = 'https://xn7n293j.hq08.lightloop.tech/api/ElectricityTradeCurves/ServiceCustomer/GetOverAll'
const tableDataUrl = 'https://xn7n293j.hq08.lightloop.tech/api/ElectricityTradeCurves/ServiceCustomer/GetServiceCustomerTable'
const curveUrl = 'https://xn7n293j.hq08.lightloop.tech/api/ElectricityTradeCurves/ServiceCustomer/GetServiceCustomerCurve'



const Page = (props) => {
  let { factoryId, date } = props.match.params;

  useEffect(() => {
    get(
      process.env.REACT_APP_SERVER_PATH +
      (props.match.url.indexOf("elestat") > -1
        ? "api/auth/checkpoint/estat"
        : "api/auth/checkpoint/eplan")
    );

  }, []);

  // 用电监测-用电计划
  let defaultCurrentMenu = 2;

  if (props.match.url.indexOf("elestat") > -1) {
    defaultCurrentMenu = 1;
  }



  const [hasAccess, setHasAccess] = useState(false);

  // const nowTime = date ? moment(date) : moment();
  // const [currentDate, setCurrentDate] = useState(
  //   moment(
  //     new Date(
  //       new Date().getFullYear(),
  //       new Date().getMonth(),
  //       new Date().getDate()
  //     )
  //   )
  // );
  const [currentDate, setCurrentDate] = useState(
    date ? moment(date) : moment().startOf("day")
  );
  // const [hasBack, setHasBack] = useState(defaultCurrentMenu == 1);

  const [DailyChartColumns, setDailyChartColumns] = useState([
    ...DailyPredictionColumns,
  ]);

  const [summaryTableData, setSummaryTableData] = useState([]);

  const [dataByDay, setDataByDay] = useState();

  const [factory, setFactory] = useState("");
  const initData = (date) => {

    getChartData(date);
  };

  const backToCurrentMenu = (CurrentMenu, time) => {
    setCurrentDate(time);

    GetDailySummary(time);

    GetDailyDataByDay(time);
  };

  function GetDailySummary(date) { }

  function GetDailyDataByDay(date) { }

  const [refreshInfo, setRefreshInfo] = useState(null);
  useEffect(() => {
    if (!!refreshInfo) {
      let delay = true;
      const myInterval = setInterval(() => {
        if (delay) {
          refreshInfo?.func?.();
        }
      }, 60 * 1000 * 5);
      return () => {
        clearInterval(myInterval);
        delay = false;
      };
    }
  }, [refreshInfo]);

  const getChartData = (date) => {
    const func = () => {
      GetDailyChart(date);
    };
    setRefreshInfo({ func });
    func();
  };

  const onChange = (data) => {
    setCurrentDate(data);
    initData(data);
  };




  const buildChartOption = (data) => {
    const resData = data?.[0];

    if (!resData) return null;

    const tempYAxis = [];

    // 处理 series
    const series = resData.value.map((item) => {
      // 自动生成 yAxis
      let yAxisIndex = tempYAxis.findIndex(
        (t) => t.unit === item.unit
      );

      if (yAxisIndex < 0) {
        tempYAxis.push({
          unit: item.unit,
        });

        yAxisIndex = tempYAxis.length - 1;
      }

      // 数据处理
      const lineData = (item.data || []).map((val) => {
        if (
          val === null ||
          val === undefined ||
          isNaN(val)
        ) {
          return null;
        }

        return Number(val.toFixed(2));
      });

      // 基础线
      const line = {
        name: item.label,
        type: "line",
        yAxisIndex,
        data: lineData,
        symbolSize: 6,
      };

      // 特殊虚线
      if (
        item.label === "预测电价" ||
        item.label === "计划电量"
      ) {
        line.lineStyle = {
          width: 2,
          type: "dashed",
        };
      }

      return line;
    });

    // y轴
    const yAxis = tempYAxis.map((item) => ({
      type: "value",
      name:
        item.unit === "mwh"
          ? "电量,MWH"
          : item.unit === "元"
            ? "电价,元/MWH"
            : item.unit,
      splitLine: {
        show: false,
      },
    }));

    // echarts option
    return {
      color: resData.color || [],

      tooltip: {
        trigger: "axis",
      },

      legend: {
        top: "top",
        left: "center",
      },

      grid: {
        left: 20,
        right: 10,
        bottom: "10%",
        containLabel: true,
      },

      xAxis: {
        type: "category",
        boundaryGap: false,
        data: resData.option || [],
      },

      yAxis,

      series,
    };
  };



  const GetDailyChart = (date) => {
    const year = moment(date).year();
    const month = moment(date).month() + 1;
    const em_xday = moment(date).date();

    const params = {
      customer_id: parseInt(factoryId),
      year,
      month,
      day: em_xday,
    }
    var chartDom = document.getElementById("StackedLine");
    var myChart = echarts.init(chartDom);
    myChart.setOption({});

    Promise.all([
      postForA8bnc2ik(curveUrl, params),
      postForA8bnc2ik(tableDataUrl, params),
      postForA8bnc2ik(top1DataUrl, params),
    ])
      .then(
        ([
          DailyChart,
          tableData,
          dataByDay,
        ]) => {

          const chartData = DailyChart.data?.data
          // 折线图
          const option = buildChartOption(chartData);
          myChart.setOption(option);

          // 统计信息
          setDataByDay(dataByDay.data?.data?.[0] || '');

          let tableDatas = tableData.data?.data?.[0] || [];


          const realtime_prices = chartData?.[0]?.value?.find?.(item => (item?.label ?? null) === "实时电价")?.data || [];

          if ((tableDatas?.length ?? 0) === 24 && (realtime_prices?.length ?? 0) === 24) {
            tableDatas = tableDatas.map((item, index) => ({
              key: index,
              ...item,
              realtime_price: getFloat(realtime_prices[index], 2)
            }))
          }

          // // 添加合计行
          // const summaryRow = getSummaryRowData({
          //   columns: DailyPredictionColumns,
          //   tableData: tableDatas,
          //   cardVals: dataByDay.data?.data?.[0],
          // })

          // const tableDataNew = [summaryRow].concat(tableDatas)
          // // 注入图表信息
          // setSummaryTableData(tableDataNew);
          // 注入图表信息
          setSummaryTableData(tableDatas);

          setTimeout(() => {
            document.querySelector("table").id = "datatable";
          }, 500);
        }
      )
      .catch(() => {
        myChart.setOption({});
        // 统计信息
        setDataByDay('');

        // 注入图表信息
        setSummaryTableData([]);
      });
  };

  const getSummaryRowData = ({
    columns = [],
    tableData = [],
    cardVals = {},
  }) => {
    console.log(columns, tableData, cardVals);
    const rowData = {
      datetime: "",
      hrx: "合计",
    };

    columns
      .filter((_, index) => index > 1)
      .forEach((column) => {
        const dataKey = column.dataIndex;

        // 电价列
        if (column.title.includes("电价")) {
          // 特殊映射
          const convertKeys = [
            {
              from: "contract_price",
              to: "contract_price",
            },
            {
              from: "d0_spot_price",
              to: "d0_spot_price_daily",
            },
          ];

          const convertItem =
            convertKeys.find(
              ({ from }) => from === dataKey
            ) || null;

          // 从顶部卡片直接取值
          if (convertItem) {
            const toDataKey = convertItem.to;
            rowData[dataKey] =
              typeof cardVals?.[toDataKey] === "number" &&
                !isNaN(cardVals[toDataKey])
                ? getFloat(cardVals[toDataKey], 2)
                : "";

            return;
          }

          // 普通电价求平均
          let sum = 0;
          let count = 0;

          tableData.forEach((item) => {
            const val = item[dataKey];

            if (
              typeof val === "number" &&
              !isNaN(val)
            ) {
              sum += val;
              count++;
            }
          });

          rowData[dataKey] =
            count > 0
              ? getFloat(sum / count, 2)
              : "";
        }

        // 电量列
        else if (column.title.includes("电量")) {
          const sum = tableData.reduce((prev, cur) => {
            let val = cur[dataKey];

            // 字符串数字转 number
            if (
              typeof val === "string" &&
              val.length > 0
            ) {
              val = Number(val);
            }

            if (
              typeof val === "number" &&
              !isNaN(val)
            ) {
              return prev + val;
            }

            return prev;
          }, 0);

          rowData[dataKey] =
            sum > 0
              ? getFloat(sum, 2)
              : "";
        }
      });

    return rowData;
  };

  const getAccess = async () => {
    let res = await post(
      process.env.REACT_APP_SERVER_PATH + "api/auth/roles/user_factory",
      {
        user_id: getCachedUserInfo().user_id,
      }
    ).catch(() => {
      return {};
    });
    let hasAccess = true;
    try {
      hasAccess = res.data.results.factory_ids.some(
        (item) => item == factoryId
      );
    } catch (error) { }
    setHasAccess(hasAccess);

    if (hasAccess) {
      initData(currentDate);
    }
  };
  useEffect(() => {
    getAccess();
    get(
      "https://powerapi.lightloop.tech/api/Trader/GetCustomerById?factoryId=" +
      factoryId
    ).then((res) => {
      setFactory(res.data.name);
    });
  }, []);


  const onResize = useCallback(() => {
    ["StackedLine", "percent", "percent1"].some((id) => {
      const chartDom = document.getElementById(id);
      if (chartDom) {
        const instance = echarts.getInstanceByDom(chartDom);
        instance?.resize?.();
      }
      return false;
    });
  }, []);

  const importar = (e) => {
    const table = document.querySelector("#datatable");
    const workbook = XLSX.utils.table_to_book(table);
    XLSX.writeFile(workbook, moment(currentDate).format("YYYY-MM-DD") + "日出清结果.xlsx");


    // return ExcellentExport.excel(
    //   e.target,
    //   document.querySelector("#datatable"),
    //   moment(currentDate).format("YYYY-MM-DD") + "日出清结果.xls"
    // );
  };

  const goBack = () => {
    onChange(moment(new Date((currentDate.format("X") - 86400) * 1000)));
  };

  const goForward = () => {
    onChange(
      moment(new Date((parseInt(currentDate.format("X")) + 86400) * 1000))
    );
  };


  return (
    <div className={style["wrapper"]}>
      <div
        style={{ position: "absolute", top: 0, right: 0, bottom: 0, left: 0 }}
      >
        <DomResize mountedCall={true} onResize={onResize} />
      </div>
      {!hasAccess ? (
        <div></div>
      ) : (
        <div
          className="body-right"
          style={{ background: "rgb(230, 237, 255)", padding: 0 }}
        >
          <div>
            <div className="body-title" style={{ background: "#fff" }}>
              <div>
                <span className="parent-menu">{factory}</span>
              </div>
              <div
                style={{ marginRight: "16px" }}
                className="back-button-wrapper"
              >
                <div
                  style={{
                    position: "relative",
                    left: "-16px",
                    display: "inline",
                  }}
                >
                  {new Date(currentDate).getFullYear()}
                  <span>年</span>
                  <span>{new Date(currentDate).getMonth() + 1}</span>
                  <span>月</span>
                  {new Date(currentDate).getDate()}
                  <span style={{ marginRight: 8 }}>日</span>
                </div>
                {/* {!hasBack ? (
                  <Button
                    className="back-button"
                    onClick={() => backToCurrentMenu(1, currentDate)}
                    type="primary"
                  >
                    返回
                  </Button>
                ) : null} */}
                <div style={{ position: "relative", display: "inline" }}>
                  <span
                    onClick={() => goBack()}
                    style={{
                      fontWeight: 800,
                      fontSize: 16,
                      left: -24,
                      top: -4,
                      position: "absolute",
                      cursor: "pointer",
                      zIndex: 100000,
                    }}
                  >
                    {" "}
                    <LeftOutlined />
                  </span>
                  <span style={{ marginLeft: "-8px" }}>
                    <DatePicker
                      allowClear={false}
                      value={currentDate}
                      onChange={onChange}
                      picker="date"
                    />
                  </span>
                  <span
                    onClick={() => goForward()}
                    style={{
                      fontWeight: 800,
                      fontSize: 16,
                      top: -4,
                      position: "absolute",
                      cursor: "pointer",
                      zIndex: 100000,
                    }}
                  >
                    {" "}
                    <RightOutlined />
                  </span>
                </div>
              </div>
            </div>
            <div className="card-container">
              {/* 当日电价 */}
              <div>
                <h3>当日合约电价</h3>
                <div className="text">
                  <span className="unit">(元/MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.contract_price?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div>
                <h3>当日现货电价</h3>
                <div className="text">
                  <span className="unit">(元/MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.d0_spot_price_daily?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div style={{ borderRight: "2px solid #bbb" }}>
                <h3>当日实际电价</h3>
                <div className="text">
                  <span className="unit">(元/MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.actual_price?.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* 当日电量 */}
              <div>
                <h3>当日合约电量</h3>
                <div className="text">
                  <span className="unit">(MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.contract_mwh_daily?.toFixed(2)} /
                    {dataByDay?.contract_mwh1?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div style={{ borderRight: "2px solid #bbb" }}>
                <h3>当日实际电量</h3>
                <div className="text">
                  <span className="unit">(MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.actual_mwh?.toFixed(2)} /
                    {dataByDay?.actual_mwh1?.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* 月度电价 */}
              <div>
                <h3>本月现货均价</h3>
                <div className="text">
                  <span className="unit">(元/MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.d0_spot_price_monthly?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div style={{ borderRight: "2px solid #bbb" }}>
                <h3>本月累计电价</h3>
                <div className="text">
                  <span className="unit">(元/MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.cum_actual_price?.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* 月度电量 */}
              <div>
                <h3>本月合约电量</h3>
                <div className="text">
                  <span className="unit">(MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.contract_mwh_monthly?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div>
                <h3>累计使用电量</h3>
                <div className="text">
                  <span className="unit">(MWH)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.cum_actual_mwh?.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* 偏差 */}
              <div style={{ borderRight: "2px solid #bbb" }}>
                <h3>超额/缺额比例</h3>
                <div className="text">
                  <span className="unit">(%)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {(dataByDay?.cum_deviation_perc * 100)?.toFixed(2)} /
                    {(dataByDay?.cum_deviation_perc1 * 100)?.toFixed(2)}
                  </span>
                </div>
              </div>

              {/* 收益 */}
              <div>
                <h3>当日电费收益</h3>
                <div className="text">
                  <span className="unit">(元)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.actual_profit?.toFixed(2)}
                  </span>
                </div>
              </div>

              <div>
                <h3>本月电费收益</h3>
                <div className="text">
                  <span className="unit">(元)</span>
                  <br />
                  <span style={{ fontSize: 20 }}>
                    {dataByDay?.cum_actual_profit?.toFixed(2)}
                  </span>
                </div>
              </div>
            </div>
            <div>
              <div
                id="StackedLine"
                style={{
                  backgroundColor: "#fff",
                  margin: 24,
                  padding: 24,
                  borderRadius: 5,
                }}
              ></div>
              <div
                id="percent"
                style={{
                  fontWeight: 900,
                  display: "flex",
                  alignItems: "center",
                  backgroundColor: "#fff",
                  margin: 24,
                  padding: 24,
                  borderRadius: 5,
                }}
              >
                <h3 style={{ marginBottom: 0, fontWeight: 900 }}>
                  <span>
                    {" "}
                    操作建议: <span> {dataByDay?.suggestion || ""}</span>
                  </span>
                </h3>
              </div>
              <div
                style={{
                  backgroundColor: "#fff",
                  margin: 24,
                  borderRadius: 5,
                  position: "relative",
                }}
              >
                <h3 style={{ fontWeight: 900, padding: 20 }}>
                  数据统计
                  <span style={{ fontSize: 14, color: "#666" }}>
                    (电量：MWH，收益：万元， 电价：元/MWH)
                  </span>
                  {/* <a
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      right: 24,
                      color: "#000",
                      fontSize: 12,
                    }}
                    download={
                      moment(currentDate).format("yyyy-MM-DD") +
                      "日出清结果.xlsx"
                    }
                    onClick={importar}
                  >
                    <DownloadOutlined size={14} style={{ fontSize: 20 }} /> 下载
                  </a> */}

                  <span
                    href="#"
                    style={{
                      position: "absolute",
                      zIndex: 1000,
                      right: 24,
                      color: "#000",
                      fontSize: 12,
                      cursor: "pointer",
                    }}
                    // download={`${moment(currentDate).format("YYYY-MM-DD")}日出清结果.xlsx`}
                    onClick={(e) => {
                      // e.preventDefault();
                      importar(e);
                    }}
                  >
                    <DownloadOutlined style={{ fontSize: 20 }} /> 下载
                  </span>
                </h3>
                <Table
                  id="datatable"
                  size="small"
                  pagination={false}
                  bordered
                  rowClassName={(r, i) => (i % 2 === 0 ? "zebra" : "")}
                  // dataSource={dailyPredictionAndSum()}
                  dataSource={summaryTableData}
                  columns={DailyChartColumns}
                  scroll={{
                    x: "max-content",
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default withRouter(Page);
